import { Contract_SelfReadings } from "data/endpoints";
import React from "react";
import SelfReadingDTO from "../dtos/SelfReadingDTO";
import SelfReading from "../components/selfReading/SelfReading";
import SelfReadingHeader from "../components/selfReading/SelfReadingHeader";
import { getRouteParams } from "features/shared/helpers/routeParams";
import ContractEnergyDTO from "../dtos/ContractEnergyDTO";
import { ContractStatus } from "../enums/contractStatus";
import { useHistory } from "react-router-dom";
import Alert from "features/shared/alerts/components/Alert";
import RolesChecker from "features/customer/components/RolesChecker";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import { getSelfReadingCreateRoute } from "features/shared/helpers/routeHelper";
import { ContractType } from "features/contracts/enums/contractType";
import { useTranslation } from "react-i18next";
import { isEnabledCustomForm } from "features/requirements/helpers/requirementTypeHelper";
import DataGridState from "features/shared/components/dataGrid/DataGridState";

const selfReadingAllowedStatuses = [
  ContractStatus.Valid,
  ContractStatus.Effective,
  ContractStatus.Terminated,
];
const pageSize = 10;

interface Props {
  contractId: string;
  contractEnergy: ContractEnergyDTO;
  contractStatus: ContractStatus;
  contractType: ContractType;
}

const SelfReadingsSection = ({
  contractId,
  contractEnergy,
  contractStatus,
  contractType,
}: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // history
  const history = useHistory();

  // helpers
  const isAllowedCreateSelfReading = (): boolean => {
    if (
      contractEnergy.meterType === "C" &&
      selfReadingAllowedStatuses.includes(contractStatus)
    ) {
      return true;
    }

    return false;
  };

  // handlers
  const addSelfReadingHandler = () => {
    history.push({
      pathname: getSelfReadingCreateRoute(contractId),
      state: contractId,
    });
  };

  // sub-renders
  const renderAddSelfReadingBtn = (): JSX.Element => {
    return (
      <RenderWrapper isVisible={() => isEnabledCustomForm("ZADANISAMOODECTU")}>
        <RolesChecker enabledRoles="Contributor">
          <button
            className="btn btn-sm btn-secondary"
            onClick={addSelfReadingHandler}
          >
            {tLabels("selfReadingSection.newSelfReading")}
          </button>
        </RolesChecker>
      </RenderWrapper>
    );
  };

  const renderNoSelfReadingsAlert = () => {
    return (
      <Alert alertObj={{ alertType: "Info" }}>
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span className="mr-sm-2 mb-1 mb-sm-0">
            {tLabels("selfReadingSection.noSelfReadingAlertMessage")}
          </span>
          <div>{renderAddSelfReadingBtn()}</div>
        </div>
      </Alert>
    );
  };

  const renderItem = (item: SelfReadingDTO) => {
    return <SelfReading selfReading={item} contractType={contractType} />;
  };

  const renderHeader = () => {
    return <SelfReadingHeader />;
  };

  // render
  if (isAllowedCreateSelfReading()) {
    return (
      <DataGridState
        url={Contract_SelfReadings}
        pageSize={pageSize}
        renderItem={renderItem}
        renderHeader={renderHeader}
        routeParams={getRouteParams("contractId", contractId)}
        renderGridHeaderBtns={renderAddSelfReadingBtn}
        renderNoContent={renderNoSelfReadingsAlert}
      />
    );
  } else {
    return (
      <Alert
        alertObj={{
          alertType: "Warning",
          message: tLabels("selfReadingSection.selfReadingWarrningMessage"),
        }}
      />
    );
  }
};

export default SelfReadingsSection;
